<template>
	<div class="box">
        <Wxxcx v-if="Wxxcx" :style="{width:`${size}px`,height:`${size}px`}"></Wxxcx>
        <UnWxxcx v-else :style="{width:`${size}px`,height:`${size}px`}"></UnWxxcx>
        <Alixcx v-if="Alixcx" :style="{width:`${size}px`,height:`${size}px`}"></Alixcx>
        <UnAlixcx v-else :style="{width:`${size}px`,height:`${size}px`}"></UnAlixcx>
        <Ttxcx v-if="Ttxcx" :style="{width:`${size}px`,height:`${size}px`}"></Ttxcx>
        <UnTtxcx v-else :style="{width:`${size}px`,height:`${size}px`}"></UnTtxcx>
        <HTml v-if="HTml" :style="{width:`${size}px`,height:`${size}px`}"></HTml>
        <UnH5 v-else :style="{width:`${size}px`,height:`${size}px`}"></UnH5>
        <App v-if="App" :style="{width:`${size}px`,height:`${size}px`}"></App>
        <UnApp v-else :style="{width:`${size}px`,height:`${size}px`}"></UnApp>
    </div>
</template>

<script>
    import Wxxcx from '@/assets/xcx/Wxxcx.vue'
    import UnWxxcx from '@/assets/xcx/UnWxxcx.vue';
    import Alixcx from '@/assets/xcx/Alixcx.vue';
    import UnAlixcx from '@/assets/xcx/UnAlixcx.vue'
    import Ttxcx from '@/assets/xcx/Ttxcx.vue'
    import UnTtxcx from '@/assets/xcx/UnTtxcx.vue'
    import HTml from '@/assets/xcx/H5.vue'
    import UnH5 from '@/assets/xcx/UnH5.vue'
    import App from '@/assets/xcx/App.vue'
    import UnApp from '@/assets/xcx/UnApp.vue'
	export default {
        components:{
            Wxxcx,
            UnWxxcx,
            Alixcx,
            UnAlixcx,
            Ttxcx,
            UnTtxcx,
            UnH5,
            HTml,
            App,
            UnApp
        },
		props: {
			Wxxcx: { type: Boolean, default:false },
			Alixcx: { type: Boolean, default:false },
			Ttxcx: { type: Boolean, default:false },
			HTml: { type: Boolean, default:false },
			App: { type: Boolean, default:false },
            size:{type:Number,default:30}
		},
		data() {
			return {

			}
		},
		mounted() {
			
		},
		methods: {
			
		}
	}
</script>

<style scoped lang="scss">
    .box{
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
</style>
